<!-- 頁面標題和新增表單按鈕 - 只在表格視圖時顯示 -->
<div class="page-header" *ngIf="showTableView">
  <h3>{{ 'form.list.title' | translate }}</h3>
  <div class="header-actions">
    <!-- 儲存/取消按鈕（只在有修改時顯示） -->
    <div class="save-cancel-buttons" *ngIf="hasModifications">
      <button class="save-btn" (click)="saveAllModifications()" [title]="'form.list.save_all_modifications' | translate">
        <i class="fas fa-save"></i> {{ 'form.list.save_modifications' | translate }} ({{modifiedForms.size}})
      </button>
      <button class="cancel-btn" (click)="cancelAllModifications()" [title]="'form.list.cancel_all_modifications' | translate">
        <i class="fas fa-times"></i> {{ 'form.list.cancel_modifications' | translate }}
      </button>
    </div>
    <button class="add-form-btn" (click)="openNewFormDialog()" [title]="'form.list.add_form' | translate">
      <i class="fas fa-plus"></i> {{ 'form.list.add_form' | translate }}
    </button>
  </div>
</div>

<!-- 搜尋區域 - 只在表格視圖時顯示 -->
<div class="search-container" *ngIf="showTableView">
  <div class="search-filters">
    <div class="search-filter">
      <label for="type-filter">{{ 'form.list.category' | translate }}</label>
      <select id="type-filter" [(ngModel)]="searchType" class="form-select">
        <option value="">{{ 'form.list.all_categories' | translate }}</option>
        <option *ngFor="let type of availableTypes" [value]="type">{{ type }}</option>
      </select>
    </div>
    <div class="search-filter">
      <label for="department-filter">{{ 'form.list.department' | translate }}</label>
      <select id="department-filter" [(ngModel)]="searchDepartment" class="form-select">
        <option value="">{{ 'form.list.all_departments' | translate }}</option>
        <option *ngFor="let dept of availableDepartments" [value]="dept">{{ dept }}</option>
      </select>
    </div>
    <div class="search-filter">
      <label for="keyword-filter">{{ 'form.list.keyword' | translate }}</label>
      <input type="text" id="keyword-filter" [(ngModel)]="searchKeyword" class="form-input" [placeholder]="'form.list.search_placeholder' | translate">
    </div>
    <button class="search-button" (click)="searchForms()" [disabled]="isLoading">
      <i class="fas fa-search"></i> {{ 'form.list.search' | translate }}
    </button>
  </div>
</div>

<!-- 載入指示器 - 只在表格視圖且載入中時顯示 -->
<div *ngIf="showTableView && isLoading" class="loading-container">
  <div class="loading-spinner">
    <i class="fas fa-spinner fa-spin"></i>
    <p>{{ 'form.list.loading' | translate }}</p>
  </div>
</div>

<!-- 表單列表視圖 -->
<div *ngIf="showTableView && !isLoading" class="form-list-table">
  <table>
    <thead>
      <tr>
        <th>{{ 'form.list.category' | translate }}</th>
        <th>{{ 'form.list.form_name' | translate }}</th>
        <th>{{ 'form.list.fill_period' | translate }}</th>
        <th>{{ 'form.list.department' | translate }}</th>
        <th>{{ 'form.list.automation' | translate }}</th>
        <th>{{ 'form.list.created_time' | translate }}</th>
        <th>{{ 'form.list.record_count' | translate }}</th>
        <th>{{ 'form.list.actions' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let form of filteredData; trackBy: trackByFormName" [class.modified]="isFormModified(form.id)">
        <!-- 分類欄位 -->
        <td class="editable-field" (click)="startEditField(form.id, 'type', $event)">
          <div *ngIf="!isFieldEditing(form.id, 'type')" class="field-display">
            <span class="field-value" [class.field-placeholder]="!form.type">
              {{ form.type || ('form.list.select_category' | translate) }}
            </span>
            <i class="fas fa-edit edit-icon"></i>
          </div>
          <div *ngIf="isFieldEditing(form.id, 'type')" class="field-editor" (click)="$event.stopPropagation()">
            <!-- 一般下拉選單模式 -->
            <div *ngIf="!isCustomTypeMode(form.id)" class="type-selector">
              <select
                [(ngModel)]="form.type"
                (change)="onTypeSelectionChange(form.id, form.type)"
                (blur)="onTypeSelectBlur(form.id)"
                (keydown)="onFieldKeydown($event, form.id, 'type')"
                class="field-select"
                autofocus>
                <option value="">{{ 'form.list.select_category' | translate }}</option>
                <option *ngFor="let option of availableTypes" [value]="option">{{ option }}</option>
                <option value="__custom__">{{ 'form.list.custom_category' | translate }}</option>
              </select>
            </div>

            <!-- 自定義分類輸入模式 -->
            <div *ngIf="isCustomTypeMode(form.id)" class="custom-type-input">
              <input
                type="text"
                [(ngModel)]="customTypeInput[form.id]"
                (blur)="onCustomTypeBlur(form.id)"
                (keydown)="onCustomTypeKeydown($event, form.id)"
                [placeholder]="'form.list.enter_category_name' | translate"
                class="field-input"
                autofocus>
              <div class="custom-type-buttons">
                <button type="button" (click)="confirmCustomType(form.id)" class="btn-confirm">{{ 'form.list.confirm' | translate }}</button>
                <button type="button" (click)="cancelCustomType(form.id)" class="btn-cancel">{{ 'form.list.cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </td>

        <!-- 表單名稱（不可編輯） -->
        <td>
          <a  (click)="debugButtonClick('create', form.formName,form.id, $event)" [title]="'form.list.create_new_record' | translate">
             {{ form.formName }}
          </a>
          </td>

        <!-- 填寫週期欄位 -->
        <td class="editable-field" (click)="startEditField(form.id, 'checkPeriod', $event)">
          <div *ngIf="!isFieldEditing(form.id, 'checkPeriod')" class="field-display">
            <span class="field-value" [class.field-placeholder]="!form.checkPeriod">
              {{ getCheckPeriodText(form.checkPeriod) || ('form.list.select_period' | translate) }}
            </span>
            <i class="fas fa-edit edit-icon"></i>
          </div>
          <div *ngIf="isFieldEditing(form.id, 'checkPeriod')" class="field-editor" (click)="$event.stopPropagation()">
            <select
              [(ngModel)]="form.checkPeriod"
              (change)="updateFieldValue(form.id, 'checkPeriod', form.checkPeriod)"
              (blur)="stopEditField(form.id, 'checkPeriod')"
              (keydown)="onFieldKeydown($event, form.id, 'checkPeriod')"
              class="field-select"
              autofocus>
              <option value="">{{ 'form.list.select_period' | translate }}</option>
              <option *ngFor="let option of checkPeriodOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </td>

        <!-- 適用部門欄位 -->
        <td class="editable-field departments-field" (click)="startEditField(form.id, 'departments', $event)">
          <div *ngIf="!isFieldEditing(form.id, 'departments')" class="field-display">
            <div class="department-tags" *ngIf="form.departments && form.departments.length > 0; else noDepartments">
              <span class="department-tag" *ngFor="let dept of form.departments">{{ dept }}</span>
            </div>
            <ng-template #noDepartments>
              <span class="field-placeholder">{{ 'form.list.select_department' | translate }}</span>
            </ng-template>
            <i class="fas fa-edit edit-icon"></i>
          </div>
          <div *ngIf="isFieldEditing(form.id, 'departments')" class="field-editor departments-editor" (click)="$event.stopPropagation()">
            <app-form-tags
              [options]="availableDepartments"
              [(ngModel)]="form.departments"
              [placeholder]="'form.list.select_or_enter_departments' | translate"
              [label]="''"
              [id]="'departments-' + form.id"
              [name]="'departments-' + form.id"
              (ngModelChange)="onDepartmentTagsChange(form.id, $event)">
            </app-form-tags>
            <div class="field-actions">
              <button class="btn-sm btn-primary" (click)="stopEditField(form.id, 'departments')">
                <i class="fas fa-check"></i> {{ 'form.list.confirm_selection' | translate }}
              </button>
              <button class="btn-sm btn-secondary" (click)="cancelEditField(form.id, 'departments')">
                <i class="fas fa-times"></i> {{ 'form.list.cancel' | translate }}
              </button>
            </div>
          </div>
        </td>

        <!-- 簽核流程狀態（不可編輯） -->
        <td class="approval-flow-status">
          <div *ngIf="hasApprovalFlow(form)" class="approval-flow-indicator"
               [title]="getApprovalFlowTooltip(form)"
               (click)="showApprovalFlowDetails(form)">
            <i class="fas fa-route approval-flow-icon"></i>
          </div>
          <div *ngIf="!hasApprovalFlow(form)" class="no-approval-flow">
            <span class="no-flow-text">-</span>
          </div>
        </td>

        <!-- 建立時間（不可編輯） -->
        <td>{{ form._ts * 1000 | date:'yyyy/MM/dd' }}</td>

        <!-- 記錄數（不可編輯） -->
        <td>{{ form.filledCount }}</td>

        <!-- 操作按鈕 -->
        <td class="tools">
          <button class="icon-button" (click)="debugButtonClick('view', form.formName,form.id, $event)" [title]="'form.list.view_list' | translate">
            <i class="fas fa-list"></i>
          </button>
          <!-- <button class="icon-button" (click)="debugButtonClick('create', form.formName, $event)" title="建立新記錄">
            <i class="fas fa-plus-circle"></i>
          </button> -->
          <button class="icon-button edit-form-btn" (click)="debugButtonClick('edit', form.formName,form.id, $event)" [title]="'form.list.edit_form' | translate">
            <i class="fa fa-cog"></i>
          </button>
          <button class="icon-button link-btn" (click)="generateDirectLink(form.formName,form.id)" [title]="'form.list.generate_link' | translate">
            <i class="fas fa-link"></i>
          </button>
          <button
            class="icon-button delete-form-btn"
            (click)="debugButtonClick('delete', form.formName, form.id,$event)"
            [disabled]="isDeletingForm && deletingFormId === form.id"
            [title]="'form.list.delete_form' | translate">
            <span *ngIf="isDeletingForm && deletingFormId === form.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i *ngIf="!(isDeletingForm && deletingFormId === form.id)" class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      <tr *ngIf="filteredData.length === 0">
        <td colspan="8" class="no-data">{{ 'form.list.no_matching_forms' | translate }}</td>
      </tr>
    </tbody>
  </table>
</div>

<!-- 表單記錄視圖 (使用現有的 ShowlistComponent) -->
<div *ngIf="!showTableView" class="record-view-container">
  <div class="records-header">
    <button class="back-button" (click)="backToList()">
      <i class="fas fa-arrow-left"></i> {{ 'form.list.back_to_list' | translate }}
    </button>
    <!-- <h4>{{ selectedFormName }} - 記錄列表</h4> -->
    <!-- 移除新增記錄按鈕 -->
  </div>

  <!-- 使用現有的 ShowlistComponent -->
  <app-showlist [formName]="selectedFormName" [formId]="getFormIdByName(selectedFormName)" (dataUpdated)="onDataUpdated()"></app-showlist>
</div>

<!-- 新增彈出視窗，用於顯示動態表單 - 添加滾動支持 -->
<div *ngIf="showFormDialog" class="form-dialog-overlay">
  <div class="form-dialog">
    <div class="dialog-header">
      <h3>{{ formDialogName }} - {{ 'form.list.add_record' | translate }}</h3>
      <button class="close-button" (click)="closeFormDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="dialog-content scrollable-content">
      <!-- 使用動態表單元件，傳遞必要參數 -->
      <app-dynamic-form
        [getuseridlist] = true
        [formName]="formDialogName"
        [formid]="getFormIdByName(formDialogName)"
        (Showlist)="viewFormList($event)"
        (fillform)="createNewRecord($event,'')"
        (recordAdded)="onRecordAdded()"
        [style.width]="'100%'"
      ></app-dynamic-form>
    </div>
  </div>
</div>

<!-- 新增全螢幕彈出視窗，用於表單建立器 - 添加滾動支持 -->
<div *ngIf="showNewFormDialog" class="fullscreen-dialog">
  <div class="dialog-header">
    <h3>{{ 'form.list.add_form_title' | translate }}</h3>
    <div class="header-actions">
      <!-- 模式切換按鈕 -->
      <div class="mode-toggle">
        <button
          class="mode-btn"
          [class.active]="formBuilderMode === 'ai'"
          (click)="formBuilderMode = 'ai'; toggleFormBuilderMode()"
          [title]="'form.list.ai_mode' | translate">
          <i class="fas fa-robot"></i> {{ 'form.list.ai_mode' | translate }}
        </button>
        <button
          class="mode-btn"
          [class.active]="formBuilderMode === 'manual'"
          (click)="formBuilderMode = 'manual'; toggleFormBuilderMode()"
          [title]="'form.list.manual_mode' | translate">
          <i class="fas fa-mouse-pointer"></i> {{ 'form.list.manual_mode' | translate }}
        </button>
      </div>
      <button class="close-button" (click)="closeNewFormDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="dialog-content">
    <div class="form-builder-layout">
      <!-- 左側：AI 助手或手動建構器 -->
      <div class="form-builder-section">
        <!-- AI 模式：AI 助手 -->
        <div *ngIf="formBuilderMode === 'ai'" class="ai-mode-section">
          <div class="form-ai-helper">
            <h4>{{ 'form.list.ai_assistant' | translate }}</h4>
            <div class="ai-messages-container">
              <div *ngFor="let msg of formAiMessages" [ngClass]="msg.role" class="ai-message">
                {{ msg.content }}
              </div>
            </div>

            <!-- 輸入區塊，參考 assistant.component.html -->
            <div class="chat-input-container">
              <!-- 預覽已選擇的檔案 -->
              <div class="image-preview-container" *ngIf="formImagePreviews.length > 0">
                <div class="image-preview" *ngFor="let preview of formImagePreviews; let i = index">
                  <div class="image-wrapper">
                    <!-- 上傳中顯示進度指示 -->
                    <div *ngIf="preview.uploading" class="uploading-overlay">
                      <div class="spinner"></div>
                    </div>

                    <!-- 圖片檔案預覽 -->
                    <a *ngIf="!preview.uploading && preview.file.type.startsWith('image/')"
                       [href]="preview.url" target="_blank">
                      <img [src]="preview.url" alt="Image Preview" />
                    </a>

                    <!-- PDF 檔案預覽 -->
                    <a *ngIf="!preview.uploading && preview.file.type === 'application/pdf'" class="pdf-preview">
                      <i class="fas fa-file-pdf"></i>
                      <span class="pdf-name">{{ preview.file.name }}</span>
                    </a>

                    <!-- 移除檔案按鈕 -->
                    <button *ngIf="!preview.uploading" class="remove-image-button" (click)="removeFormImage(i)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="input-area">
                <!-- 檔案上傳按鈕 -->
                <button type="button" class="upload-button" (click)="triggerFormFileUpload()" [title]="'form.list.upload_image' | translate">
                  <i class="fas fa-paperclip"></i>
                </button>

                <!-- 隱藏的檔案上傳框 -->
                <input type="file" accept=".jpg, .jpeg, .png, .pdf" id="formFileInput" (change)="onFormFilesSelected($event)" multiple hidden />

                <!-- 文本輸入區域 -->
                <div class="textarea-container">
                  <textarea
                    [(ngModel)]="formAiMessage"
                    [placeholder]="'form.list.ai_placeholder' | translate"
                    (input)="autoResizeFormInput($event)"
                    (keydown)="onFormKeyDown($event)">
                  </textarea>
                </div>

                <!-- 送出按鈕 -->
                <button
                  type="button"
                  class="send-button"
                  (click)="askFormAi()"
                  [disabled]="isFormSending">
                  <span *ngIf="isFormSending" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span *ngIf="!isFormSending">{{ 'form.list.send' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 手動模式：表單建構器 -->
        <div *ngIf="formBuilderMode === 'manual'" class="manual-mode-section">
          <app-form-builder
            #newFormBuilder
            [initialConfig]="manualFormConfig"
            (configChange)="onManualConfigChange($event)"
            (previewChange)="onManualPreviewChange($event)"
          ></app-form-builder>
        </div>
      </div>

      <!-- 右側：統一的表單預覽區域 -->
      <div class="form-preview-section">
        <div class="preview-header">
          <h4><i class="fas fa-eye"></i> {{ 'form.list.real_time_preview' | translate }}</h4>
        </div>
        <div class="preview-content scrollable-content">
          <!-- 統一的動態表單元件 -->
          <app-dynamic-form
            [formName]="newFormName"
            [preview]="true"
            [config]="getUnifiedFormConfig()"
            [formid]="getFormIdByName(newFormName)"
            (Showlist)="onFormShowList($event)"
            (fillform)="onFormFill($event)"
            (formSaved)="onFormSaved($event)"
            (configChanged)="onUnifiedPreviewConfigChanged($event)"
            (recordAdded)="onRecordAdded()"
          ></app-dynamic-form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 編輯表單配置對話框 -->
<div *ngIf="showEditFormDialog" class="fullscreen-dialog">
  <div class="dialog-header">
    <h3>{{ 'form.list.edit_form_config' | translate }} - {{ editingFormConfig?.formName }}</h3>
    <div class="header-actions">
      <!-- 模式切換按鈕 -->
      <div class="mode-toggle">
        <button
          class="mode-btn"
          [class.active]="editFormBuilderMode === 'ai'"
          (click)="editFormBuilderMode = 'ai'; toggleEditFormBuilderMode()"
          [title]="'form.list.ai_mode' | translate">
          <i class="fas fa-robot"></i> {{ 'form.list.ai_mode' | translate }}
        </button>
        <button
          class="mode-btn"
          [class.active]="editFormBuilderMode === 'manual'"
          (click)="editFormBuilderMode = 'manual'; toggleEditFormBuilderMode()"
          [title]="'form.list.manual_mode' | translate">
          <i class="fas fa-mouse-pointer"></i> {{ 'form.list.manual_mode' | translate }}
        </button>
      </div>
      <button class="close-button" (click)="closeEditFormDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="dialog-content">
    <div class="form-builder-layout">
      <!-- 左側：AI 助手或手動建構器 -->
      <div class="form-builder-section">
        <!-- AI 模式：AI 助手 -->
        <div *ngIf="editFormBuilderMode === 'ai'" class="ai-mode-section">
          <div class="form-ai-helper">
            <h4>{{ 'form.list.ai_assistant' | translate }}</h4>
            <div class="ai-messages-container">
              <div *ngFor="let msg of editFormAiMessages" [ngClass]="msg.role" class="ai-message">
                {{ msg.content }}
              </div>
            </div>

            <!-- 輸入區塊 -->
            <div class="chat-input-container">
              <!-- 預覽已選擇的檔案 -->
              <div class="image-preview-container" *ngIf="editFormImagePreviews.length > 0">
                <div class="image-preview" *ngFor="let preview of editFormImagePreviews; let i = index">
                  <div class="image-wrapper">
                    <!-- 上傳中顯示進度指示 -->
                    <div *ngIf="preview.uploading" class="uploading-overlay">
                      <div class="spinner"></div>
                    </div>

                    <!-- 圖片檔案預覽 -->
                    <a *ngIf="!preview.uploading && preview.file.type.startsWith('image/')"
                       [href]="preview.url" target="_blank">
                      <img [src]="preview.url" alt="Image Preview" />
                    </a>

                    <!-- PDF 檔案預覽 -->
                    <a *ngIf="!preview.uploading && preview.file.type === 'application/pdf'" class="pdf-preview">
                      <i class="fas fa-file-pdf"></i>
                      <span class="pdf-name">{{ preview.file.name }}</span>
                    </a>

                    <!-- 移除檔案按鈕 -->
                    <button *ngIf="!preview.uploading" class="remove-image-button" (click)="removeEditFormImage(i)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="input-area">
                <!-- 檔案上傳按鈕 -->
                <button type="button" class="upload-button" (click)="triggerEditFormFileUpload()" [title]="'form.list.upload_image' | translate">
                  <i class="fas fa-paperclip"></i>
                </button>

                <!-- 隱藏的檔案上傳框 -->
                <input type="file" accept=".jpg, .jpeg, .png, .pdf" id="editFormFileInput" (change)="onEditFormFilesSelected($event)" multiple hidden />

                <!-- 文本輸入區域 -->
                <div class="textarea-container">
                  <textarea
                    [(ngModel)]="editFormAiMessage"
                    [placeholder]="'form.list.ai_modify_placeholder' | translate"
                    (input)="autoResizeEditFormInput($event)"
                    (keydown)="onEditFormKeyDown($event)">
                  </textarea>
                </div>

                <!-- 送出按鈕 -->
                <button
                  type="button"
                  class="send-button"
                  (click)="askEditFormAi()"
                  [disabled]="isEditFormSending">
                  <span *ngIf="isEditFormSending" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span *ngIf="!isEditFormSending">{{ 'form.list.send' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 手動模式：表單建構器 -->
        <div *ngIf="editFormBuilderMode === 'manual'" class="manual-mode-section">
          <app-form-builder
            #editFormBuilder
            [initialConfig]="editManualFormConfig"
            (configChange)="onEditManualConfigChange($event)"
            (previewChange)="onEditManualPreviewChange($event)"
          ></app-form-builder>
        </div>
      </div>

      <!-- 右側：統一的表單預覽區域 -->
      <div class="form-preview-section">
        <div class="preview-header">
          <h4><i class="fas fa-eye"></i> {{ 'form.list.real_time_preview' | translate }}</h4>
        </div>
        <div class="preview-content scrollable-content">
          <!-- 統一的動態表單元件 -->
          <app-dynamic-form
            [formName]="editingFormConfig?.formName || 'Preview'"
            [preview]="true"
            [editMode]="true"
            [editFormId]="editingFormConfig?.id"
            [formid]="editingFormConfig?.id || ''"
            [config]="getUnifiedEditFormConfig()"
            (Showlist)="onEditFormShowList($event)"
            (fillform)="onEditFormFill($event)"
            (configChanged)="onUnifiedEditPreviewConfigChanged($event)"
          ></app-dynamic-form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- QR Code 分享彈出視窗 -->
<div *ngIf="showQrModal" class="qr-modal-overlay">
  <div class="qr-modal">
    <div class="qr-modal-header">
      <h3>{{ currentFormName }} - {{ 'form.list.direct_link_share' | translate }}</h3>
      <button class="close-button" (click)="closeQrModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="qr-modal-content">
      <div class="url-section">
        <label>{{ 'form.list.direct_link' | translate }}</label>
        <div class="url-input-group">
          <input type="text" [value]="generatedUrl" readonly class="url-input">
          <button class="copy-button" (click)="copyLinkToClipboard()" [title]="'form.list.copy_link' | translate">
            <i class="fas fa-copy"></i>
          </button>
        </div>
      </div>

      <div class="qr-section" *ngIf="qrCodeImage">
        <label>{{ 'form.list.qr_code' | translate }}</label>
        <div class="qr-code-container">
          <img [src]="qrCodeImage" alt="QR Code" class="qr-code-image">
        </div>
        <div class="qr-actions">
          <button class="download-button" (click)="downloadQRCode()">
            <i class="fas fa-download"></i> {{ 'form.list.download_qr' | translate }}
          </button>
        </div>
      </div>

      <div class="usage-info">
        <p><i class="fas fa-info-circle"></i> {{ 'form.list.qr_usage_info' | translate: {formName: currentFormName} }}</p>
      </div>
    </div>
  </div>
</div>

<!-- 簽核流程詳細資訊 Modal -->
<div *ngIf="showApprovalFlowModal" class="approval-flow-modal-overlay">
  <div class="approval-flow-modal">
    <div class="approval-flow-modal-header">
      <h3>
        <i class="fas fa-route"></i>
       {{ selectedApprovalFlowForm?.formName }}
      </h3>
      <button class="close-button" (click)="closeApprovalFlowModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="approval-flow-modal-content">
      <!-- 基本資訊區塊 -->
      <!-- <div class="approval-flow-info" *ngIf="selectedApprovalFlowConfig">
        <div class="info-section">
          <h4><i class="fas fa-info-circle"></i> 基本資訊</h4>
          <div class="info-grid">
            <div class="info-item">
              <label>欄位標籤:</label>
              <span>{{ selectedApprovalFlowConfig.label }}</span>
            </div>
            <div class="info-item">
              <label>欄位ID:</label>
              <span>{{ selectedApprovalFlowConfig.id }}</span>
            </div>
            <div class="info-item" *ngIf="selectedApprovalFlowConfig.approvalFlowId">
              <label>簽核流程ID:</label>
              <span>{{ selectedApprovalFlowConfig.approvalFlowId }}</span>
            </div>
            <div class="info-item" *ngIf="selectedApprovalFlowConfig.required">
              <label>必填欄位:</label>
              <span class="required-badge">是</span>
            </div>
          </div>
        </div>

        <div class="info-section" *ngIf="selectedApprovalFlowConfig.placeholder">
          <h4><i class="fas fa-quote-left"></i> 提示文字</h4>
          <p class="placeholder-text">{{ selectedApprovalFlowConfig.placeholder }}</p>
        </div>
      </div> -->

      <!-- 簽核流程詳細內容區塊 -->
      <div class="approval-flow-details" *ngIf="selectedApprovalFlowDefinition">
        <div class="info-section">
          <!-- <h4><i class="fas fa-cogs"></i> 簽核流程內容</h4> -->

          <div class="flow-preview-card">
            <div class="flow-preview-header">
              <i class="fas fa-check-circle flow-icon"></i>
              <span class="flow-name">{{ selectedApprovalFlowDefinition.name }}</span>
              <span class="flow-status active">{{ 'form.list.active' | translate }}</span>
            </div>

            <div class="flow-preview-content">
              <div class="flow-description" *ngIf="selectedApprovalFlowDefinition.description">
                <p>{{ selectedApprovalFlowDefinition.description }}</p>
              </div>

              <div class="flow-steps" *ngIf="selectedApprovalFlowDefinition.steps?.length">
                <div class="steps-label">{{ 'form.list.approval_steps' | translate }}</div>
                <div class="steps-list">
                  <div
                    *ngFor="let step of selectedApprovalFlowDefinition.steps; let i = index"
                    class="step-preview"
                  >
                    <span class="step-number">{{ step.order }}</span>
                    <span class="step-content">
                      <span class="step-name">{{ step.name }}</span>
                      <span class="step-approver">
                        <ng-container *ngIf="step.approverType === 'role_based'">
                          - {{ step.departmentName || ('form.list.department' | translate) }} / {{ step.roleName || ('approval.flow.role_based' | translate) }}
                        </ng-container>
                        <ng-container *ngIf="step.approverType === 'specific_user'">
                          - {{ step.userName || ('approval.flow.specified_person' | translate) }}
                        </ng-container>
                      </span>
                      <div class="step-requirements" *ngIf="step.requireComment || step.requireSignature">
                        <span class="requirement-tag" *ngIf="step.requireComment">
                          <i class="fas fa-comment"></i> {{ 'form.list.require_comment' | translate }}
                        </span>
                        <span class="requirement-tag" *ngIf="step.requireSignature">
                          <i class="fas fa-signature"></i> {{ 'form.list.require_signature' | translate }}
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <div class="flow-meta" *ngIf="selectedApprovalFlowDefinition.steps?.length">
                <span class="meta-item">
                  <i class="fas fa-list"></i>
                  {{ 'form.list.total_steps' | translate: {count: selectedApprovalFlowDefinition.steps.length} }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 沒有載入到簽核流程定義時的顯示 -->
      <div class="no-flow-definition" *ngIf="!selectedApprovalFlowDefinition && selectedApprovalFlowConfig">
        <div class="info-section">
          <h4><i class="fas fa-exclamation-triangle"></i> {{ 'approval.flow.status' | translate }}</h4>
          <div class="status-info">
            <span class="status-badge active">
              <i class="fas fa-check-circle"></i>
              {{ 'form.list.approval_flow_enabled' | translate }}
            </span>
            <p class="status-note">
              <i class="fas fa-info-circle"></i>
              {{ 'form.list.approval_flow_check' | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="approval-flow-modal-footer">
      <button class="btn-secondary" (click)="closeApprovalFlowModal()">
        <i class="fas fa-times"></i> {{ 'form.list.close' | translate }}
      </button>
    </div>
  </div>
</div>
